import { render, staticRenderFns } from "./tax-list.vue?vue&type=template&id=e68d9af6"
import script from "./tax-list.vue?vue&type=script&lang=js"
export * from "./tax-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxModal: require('/home/ubuntu/complete-nuxt-js/components/tax-modal.vue').default})
